import React, {Component} from 'react';
import {connect} from 'react-redux';
import { path } from 'ramda';

import Box from 'components/box';
import {AccostDetailList} from './accost-detail-list';
import Textarea from 'form/textarea';
import {ButtonDefault, ButtonDanger} from 'components/buttons';
import {Actions} from 'components/actions';
import {Divider} from 'components/common';

import {loadAccostDetail, changeAccostStatus, changeAccostAnswer} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  accost: state.institutions.get('accostDetail')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadAccostDetail(id)),
  changeStatus : (id, status) => dispatch(changeAccostStatus(id, status)),
  changeAnswer : (id, answer) => dispatch(changeAccostAnswer(id, answer))
});

class ReviewDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      comment: ""
    }
    this.changeComment = this.changeComment.bind(this);
  }

  changeComment(event) {
    this.setState({comment: event.target.value});
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.review_id)
  }

  componentWillReceiveProps (nextProps) {
    if(nextProps.accost){
      const answer = nextProps.accost.get('answer')
      this.setState(() => ({comment: answer}))
    }
  }

  render() {

    const { accost } = this.props;

    if (this.props.accost === undefined) {
      return null;
    }

    return(
      <Box title4={`${path(['location', 'state', 'name'], this.props) || 'Звернення'} користувача`}>
        <AccostDetailList accost={accost} />
        {accost.get('answer') &&
            <p>Коментар до відповіді: <strong>{accost.get('answer')}</strong></p>
        }
        <Divider>
          <Textarea
            block
            label="Коментар до відповіді"
            value={this.state.comment ? this.state.comment : ""}
            onChange={this.changeComment}
            placeholder="Введіть коментар до відповіді"
          />

        </Divider>
          <Actions>
              <li>
                <ButtonDefault onClick={() => {
                  this.props.changeStatus(this.props.accost.get('id'), 1)
                  this.props.changeAnswer(this.props.accost.get('id'), this.state.comment)
                }} value="Прийняти" />
              </li>
              <li>
                <ButtonDanger onClick={() => {
                  this.props.changeStatus(this.props.accost.get('id'), 2)
                  this.props.changeAnswer(this.props.accost.get('id'), this.state.comment)
                }} value="Відхилити" />
              </li>
          </Actions>
      </Box>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewDetail);



// WEBPACK FOOTER //
// ./src/administration/reviews/detail.js